/**
 * @generated SignedSource<<eeca4afa709ee9fc610b2b8e066aea4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainUniversal_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly isOrg: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AttachedContentTodo_todo" | "TodoContact_todo" | "TodoEditNewMainCreationInfo" | "TodoEditNewMainMediaComponentMedia_todo" | "TodoEditNewMainOrgTitleAndDescription_todo" | "TodoEditNewMainParentIndicator_todo" | "TodoEditNewMainStoreTitleAndDescription_todo" | "TodoEditNewMainSubTodos_todo" | "TodoEditNewMainToolbar_todo">;
  readonly " $fragmentType": "TodoEditNewMainUniversal_todo";
};
export type TodoEditNewMainUniversal_todo$key = {
  readonly " $data"?: TodoEditNewMainUniversal_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainUniversal_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainUniversal_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainCreationInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainStoreTitleAndDescription_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainMediaComponentMedia_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainToolbar_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainParentIndicator_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainOrgTitleAndDescription_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AttachedContentTodo_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoContact_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainSubTodos_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "46f502998380961ec13543374b8e62a6";

export default node;
